import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {useUpmPlant} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {ExpertSystemUsageContainer} from '@widgets/expert-system'

import {useOptimizationSpecialistTimeRange} from '../hooks'

type Props = {
  plantId: string
  cockpitHref?: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const OptimizationSpecialistExpertSystemContainer: React.FC<Props> = ({
  plantId,
  cockpitHref,
  cardBoxSx,
  placeholderWrapperSx
}) => {
  const {start, end} = useOptimizationSpecialistTimeRange(plantId)
  const {upmId: upmPlantId} = useUpmPlant({plantId})
  const from = start?.toISOString()
  const to = end?.toISOString()

  return (
    <CardLinkWrapper href={cockpitHref} data-test-id="expert-system-card-link-to-shift-summary">
      <ExpertSystemUsageContainer
        hierarchyId={upmPlantId}
        from={from}
        to={to}
        cardBoxSx={cardBoxSx}
        placeholderWrapperSx={placeholderWrapperSx}
      />
    </CardLinkWrapper>
  )
}
